import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        padding: theme.spacing(2, 0),
    },
    noPadding: {
        padding: 0,
    }
}));

type OwnProps = {
    className ?: string;
    value ?: number;
    variant ?: 'determinate' | 'indeterminate';
    size ?: number | string;
    noPadding ?: boolean;
};

type Props = OwnProps;

const InlineLoadingIndicator : React.FC<Props> = ({className, value, variant, size, noPadding} : Props) => {
    const classes = useStyles();

    return (
        <div className={classNames(classes.root, noPadding ? classes.noPadding : undefined, className)}>
            <CircularProgress value={value} variant={variant} size={size}/>
        </div>
    );
};

export default InlineLoadingIndicator;
